import { render, staticRenderFns } from "./EditArticle.vue?vue&type=template&id=b4ebabea&scoped=true&"
import script from "./EditArticle.vue?vue&type=script&lang=js&"
export * from "./EditArticle.vue?vue&type=script&lang=js&"
import style0 from "./EditArticle.vue?vue&type=style&index=0&id=b4ebabea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ebabea",
  null
  
)

export default component.exports